import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la voz",
    opening: localizedGenderNode(
      [
      "Hoy no intento silenciar la voz.",
      "Solo la noto.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento silenciar la voz.",
      "Solo la noto.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se despierta la voz crítica?",
      "¿Qué suele decirme?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se despierta la voz crítica?",
      "¿Qué suele decirme?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la voz ya es un comienzo."
    ],
      [
      "Notar la voz ya es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "De dónde viene",
    opening: localizedGenderNode(
      [
      "Hoy noto de dónde vino la voz.",
      "Sin culpa.",
      "Solo ver."
    ],
      [
      "Hoy noto de dónde vino la voz.",
      "Sin culpa.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De quién aprendí esta voz?",
      "¿Cuándo la escuché por primera vez?",
      "¿Qué me hizo entonces?"
    ],
      [
      "¿De quién aprendí esta voz?",
      "¿Cuándo la escuché por primera vez?",
      "¿Qué me hizo entonces?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el origen suaviza el presente."
    ],
      [
      "Ver el origen suaviza el presente."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre el origen.",
      "escribir una palabra sobre el origen."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Qué intenta evitar",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué intenta evitar la voz.",
      "No para justificar.",
      "Solo entender."
    ],
      [
      "Hoy pregunto qué intenta evitar la voz.",
      "No para justificar.",
      "Solo entender."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué teme la voz que pase si suelto?",
      "¿De qué intenta protegerme?",
      "¿Cuál es el costo para mí?"
    ],
      [
      "¿Qué teme la voz que pase si suelto?",
      "¿De qué intenta protegerme?",
      "¿Cuál es el costo para mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Esa voz también intenta protegerme."
    ],
      [
      "Esa voz también intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La parte que fue herida",
    opening: localizedGenderNode(
      [
      "Hoy noto la parte herida por esa voz.",
      "No para arreglarla.",
      "Solo estar con ella."
    ],
      [
      "Hoy noto la parte herida por esa voz.",
      "No para arreglarla.",
      "Solo estar con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ],
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar con él un momento ya es un cambio pequeño."
    ],
      [
      "Estar con él un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "poner una mano en el corazón y respirar.",
      "poner una mano en el corazón y respirar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Ver el costo",
    opening: localizedGenderNode(
      [
      "Hoy veo el costo que la voz cobra.",
      "No para culpar.",
      "Solo ver."
    ],
      [
      "Hoy veo el costo que la voz cobra.",
      "No para culpar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el costo que pago por esa voz?",
      "¿Qué pierdo en el camino?",
      "¿Qué me gustaría que fuera diferente?"
    ],
      [
      "¿Cuál es el costo que pago por esa voz?",
      "¿Qué pierdo en el camino?",
      "¿Qué me gustaría que fuera diferente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el costo abre espacio para un pequeño cambio."
    ],
      [
      "Ver el costo abre espacio para un pequeño cambio."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre el costo.",
      "escribir una palabra sobre el costo."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Pedir suavidad",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña de suavidad.",
      "No grande.",
      "Solo pequeña."
    ],
      [
      "Hoy formulo una petición pequeña de suavidad.",
      "No grande.",
      "Solo pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me gustaría que me hablaran?",
      "¿Cómo puedo hablarme así?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Cómo me gustaría que me hablaran?",
      "¿Cómo puedo hablarme así?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña suavidad puede abrir la respiración."
    ],
      [
      "Una pequeña suavidad puede abrir la respiración."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo frente a la voz.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo frente a la voz.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es una pequeña reparación."
    ],
      [
      "Quedarme conmigo es una pequeña reparación."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite frente a la voz",
    opening: localizedGenderNode(
      [
      "Hoy observo un límite pequeño frente a la voz.",
      "No para pelear.",
      "Solo proteger."
    ],
      [
      "Hoy observo un límite pequeño frente a la voz.",
      "No para pelear.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo la voz cruza un límite para mí?",
      "¿Qué frase de límite ayudaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Cuándo la voz cruza un límite para mí?",
      "¿Qué frase de límite ayudaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño protege el corazón."
    ],
      [
      "Un límite pequeño protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Escuchar otra voz también",
    opening: localizedGenderNode(
      [
      "Hoy observo si hay otra voz en mí.",
      "Pequeña.",
      "Pero existe."
    ],
      [
      "Hoy observo si hay otra voz en mí.",
      "Pequeña.",
      "Pero existe."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me dice una voz más suave?",
      "¿Cuándo la escucho?",
      "¿Cómo se siente escucharla?"
    ],
      [
      "¿Qué me dice una voz más suave?",
      "¿Cuándo la escucho?",
      "¿Cómo se siente escucharla?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz suave puede abrir espacio."
    ],
      [
      "Una voz suave puede abrir espacio."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase suave.",
      "escribir una frase suave."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Pedir un gesto suave",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo pedir un gesto suave.",
      "Sin drama.",
      "Una petición pequeña."
    ],
      [
      "Hoy observo cómo pedir un gesto suave.",
      "Sin drama.",
      "Una petición pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué gesto suave me falta?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué gesto suave me falta?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar."
    ],
      [
      "Una petición puede suavizar."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor más allá de la crítica",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor más allá de la voz crítica.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor más allá de la voz crítica.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa de verdad?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa de verdad?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor puede ser un ancla."
    ],
      [
      "Un valor puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Escucharme",
    opening: localizedGenderNode(
      [
      "Hoy practico escucharme frente a la voz crítica.",
      "No para apartarla.",
      "Solo escuchar."
    ],
      [
      "Hoy practico escucharme frente a la voz crítica.",
      "No para apartarla.",
      "Solo escuchar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ],
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escucharme es una pequeña reparación."
    ],
      [
      "Escucharme es una pequeña reparación."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de aceptación",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la suavidad interna.",
      "Cuando me siento juzgado/a.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la suavidad interna.",
      "Cuando me siento juzgado/a.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta voz?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta voz?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo escuchar crítica y aun así quedarme conmigo."
    ],
      [
      "Puedo escuchar crítica y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintEs = buildNormalizedPilotBlueprint({
  id: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
    en: "Harsh criticism of a parent that lives inside me to this day",
    es: "Crítica dura de un padre que vive dentro de mí hasta hoy",
  },
  days,
});

export default harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintEs;
